var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionBank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37,
    height: 40,
    viewBox: "0 0 37 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_63",
    "data-name": "Group 63",
    transform: "translate(-813 -127)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_64",
    "data-name": "Group 64",
    transform: "translate(813 127)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61",
    "data-name": "Group 61"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_55",
    "data-name": "Group 55",
    transform: "translate(0 13.714)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_5",
    "data-name": "Rectangle 5",
    transform: "translate(0 0.286)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 12,
    rx: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 36,
    height: 11,
    rx: 1.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_12",
    "data-name": "Line 12",
    y2: 11.429,
    transform: "translate(10.857 0.571)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_52",
    "data-name": "Group 52",
    transform: "translate(3.375 2.479)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26",
    "data-name": "Group 26"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M37.25,57.592a2.654,2.654,0,0,0-2.65,2.65.723.723,0,0,0,1.446,0,1.2,1.2,0,1,1,1.2,1.2.723.723,0,0,0,0,1.446,2.65,2.65,0,1,0,0-5.3Z",
    transform: "translate(-34.6 -57.592)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_53",
    "data-name": "Group 53",
    transform: "translate(5.306 8.647)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28",
    "data-name": "Group 28",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M56.99,126.791h0a.727.727,0,1,0,.008,0Z",
    transform: "translate(-56.267 -126.791)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_60",
    "data-name": "Group 60"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_54",
    "data-name": "Group 54"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_5-2",
    "data-name": "Rectangle 5",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 13,
    rx: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 36,
    height: 12,
    rx: 1.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_12-2",
    "data-name": "Line 12",
    y2: 11.429,
    transform: "translate(10.857 0.571)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_52-2",
    "data-name": "Group 52",
    transform: "translate(3.375 2.479)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26-2",
    "data-name": "Group 26"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_60-2",
    "data-name": "Path 60",
    d: "M37.25,57.592a2.654,2.654,0,0,0-2.65,2.65.723.723,0,0,0,1.446,0,1.2,1.2,0,1,1,1.2,1.2.723.723,0,0,0,0,1.446,2.65,2.65,0,1,0,0-5.3Z",
    transform: "translate(-34.6 -57.592)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_53-2",
    "data-name": "Group 53",
    transform: "translate(5.306 8.647)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28-2",
    "data-name": "Group 28",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_61-2",
    "data-name": "Path 61",
    d: "M56.99,126.791h0a.727.727,0,1,0,.008,0Z",
    transform: "translate(-56.267 -126.791)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_57",
    "data-name": "Group 57",
    transform: "translate(13.714 4.571)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_13",
    "data-name": "Line 13",
    x1: 13,
    transform: "translate(0.286 0.429)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_14",
    "data-name": "Line 14",
    x1: 5,
    transform: "translate(0.286 2.429)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_15",
    "data-name": "Line 15",
    x1: 10,
    transform: "translate(8.286 2.429)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_58",
    "data-name": "Group 58",
    transform: "translate(13.714 18.286)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_13-2",
    "data-name": "Line 13",
    x1: 13,
    transform: "translate(0.286 -0.286)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_14-2",
    "data-name": "Line 14",
    x1: 5,
    transform: "translate(0.286 2.714)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_15-2",
    "data-name": "Line 15",
    x1: 10,
    transform: "translate(8.286 2.714)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_62",
    "data-name": "Group 62",
    transform: "translate(0 27.429)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_56",
    "data-name": "Group 56",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_5-3",
    "data-name": "Rectangle 5",
    transform: "translate(0 -0.429)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 13,
    rx: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 36,
    height: 12,
    rx: 1.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_12-3",
    "data-name": "Line 12",
    y2: 11.429,
    transform: "translate(10.857 0.571)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_52-3",
    "data-name": "Group 52",
    transform: "translate(3.375 2.479)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26-3",
    "data-name": "Group 26"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_60-3",
    "data-name": "Path 60",
    d: "M37.25,57.592a2.654,2.654,0,0,0-2.65,2.65.723.723,0,0,0,1.446,0,1.2,1.2,0,1,1,1.2,1.2.723.723,0,0,0,0,1.446,2.65,2.65,0,1,0,0-5.3Z",
    transform: "translate(-34.6 -57.592)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_53-3",
    "data-name": "Group 53",
    transform: "translate(5.306 8.647)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28-3",
    "data-name": "Group 28",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_61-3",
    "data-name": "Path 61",
    d: "M56.99,126.791h0a.727.727,0,1,0,.008,0Z",
    transform: "translate(-56.267 -126.791)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_59",
    "data-name": "Group 59",
    transform: "translate(13.714 4.571)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_13-3",
    "data-name": "Line 13",
    x1: 13,
    transform: "translate(0.286)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_14-3",
    "data-name": "Line 14",
    x1: 5,
    transform: "translate(0.286 2)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_15-3",
    "data-name": "Line 15",
    x1: 10,
    transform: "translate(8.286 2)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionBank);
export default __webpack_public_path__ + "static/media/question-bank.dbb6d4acefd6aa1f5c7ec2aff84411d2.svg";
export { ForwardRef as ReactComponent };